import { Padding } from 'types';

type AddBackgroundImageProps = {
  html: string;
  backgroundImage: string;
  textPadding?: Padding;
};

export const addBackgroundImage = ({
  html,
  backgroundImage,
  textPadding,
}: AddBackgroundImageProps) => `
<html>
  <head>
    <style>
      html, body {
        margin: 0;
        padding: 0;
        height: 100%;
      }

      .page {
        width: 100%;
        height: 100%;
        position: relative;
      }

      .background-image {
        position: absolute;
        inset: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        z-index: 0;
      }

      .content {
        position: relative;
        z-index: 1;
        box-sizing: border-box;

        padding-top: ${textPadding?.top || '20mm'};
        padding-right: ${textPadding?.right || '24mm'};
        padding-bottom: ${textPadding?.bottom || '20mm'};
        padding-left: ${textPadding?.left || '24mm'};
      }
    </style>
  </head>
  <body>
    <div class="page">
      <img class="background-image" src="${backgroundImage}" />
      <div class="content">
        ${html}
      </div>
    </div>
  </body>
</html>
`;
